import React from "react";
//import { Link } from "react-router-dom";

export const faqs = [
  {
    title: "xxx",
    content: <div>xxx</div>,
  },
];
